<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNetHaUnitsByAudiologist',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'net_units_sold', throughMonth),
          this.getYtdByField(yearObj, 'number_providers', throughMonth),
        );
      },
    },
  };
</script>
